import { fetchAuthSession } from 'aws-amplify/auth'

import config from '@/amplify_outputs.json'
import { ensureClientAmplifyConfigured } from '@/services/amplify/configureClientAmplify'
import {
  fetchAccountStatus,
  getAccountApiEndpoint,
  postAccountCommand,
} from './accountLifecycle.shared'

export function accountApiEndpoint() {
  return getAccountApiEndpoint(config)
}

export async function recordAccountActivity() {
  ensureClientAmplifyConfigured()
  const session = await fetchAuthSession()
  const token = session.tokens?.idToken?.toString()
  if (!token) throw new Error('Authentication required')
  const response = await postAccountCommand(
    accountApiEndpoint(),
    '/account/activity',
    {},
    token,
  )
  if (!response.ok) throw new Error('Activity unavailable')
}

export async function readAccountStatus() {
  ensureClientAmplifyConfigured()
  const session = await fetchAuthSession()
  const token = session.tokens?.idToken?.toString()
  if (!token) throw new Error('Account status unavailable')
  return fetchAccountStatus(accountApiEndpoint(), token)
}
